import { EventTracker } from "@devexpress/dx-react-chart";
import { ArgumentAxis, Chart, Legend, LineSeries, Title, ValueAxis, Tooltip } from "@devexpress/dx-react-chart-material-ui";
import { Paper } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { useWindowSize } from "../../../helpers/use-window-size";
import { IParkingLotChartProps } from "./props";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkingLotChart(props: IParkingLotChartProps)
{
    const [width, height] = useWindowSize();

    const PREFIX = "parkir";

    const classes = {
        chart: `${PREFIX}-chart`
    };

    /** New React component derived from the original Chart component, extended with some styling. */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const StyledChart = styled(Chart)(() => ({
        [`&.${classes.chart}`]: {
            paddingRight: "20px"
        }
    }));

    // Somehow, sx param does not work properly, so I used style prop to ensure the css application.

    /** New React component for title text. */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const TitleText = (titleTextProps: any) => (
        <Title.Text {...titleTextProps} sx={{ whiteSpace: "pre" }} style={{ whiteSpace: "pre" }} />
    );

    /** A function that returns a tick formatted function. */
    const format = () => (tick: any) => tick;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const ValueLabel = (valueLabelProps: any) =>
    {
        const { text } = valueLabelProps;
        return (
            <ValueAxis.Label
                {...valueLabelProps}
                text={`${text}`}
            />
        );
    };

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const ArgumentLabel = (argumentLabelProps: any) =>
    {
        const { text } = argumentLabelProps;
        return (
            <ArgumentAxis.Label
                {...argumentLabelProps}
                // text={`${text}`}
                text=""
            />
        );
    };

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const CustomizedTooltip = (tooltipProps: Tooltip.ContentProps) => (
        <Tooltip.Content {...tooltipProps} text={props.data[tooltipProps.targetItem.point].date + " - " + tooltipProps.text} />
    );

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const Root = (rootProps: any) =>
    {
        let display = width > 726 ? "flex" : "block";
        return (
            <Legend.Root
                {...rootProps}
                sx={{ display: display, margin: "auto", flexDirection: "row" }}
                style={{ display: display, margin: "auto", flexDirection: "row" }}
            />
        );
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const Label = (labelProps: any) => (
        <Legend.Label sx={{ pt: 1, whiteSpace: "nowrap" }} style={{ pt: 1, whiteSpace: "nowrap" }} {...labelProps} />
    );
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const LegendItem = (legendItemProps: any) => (
        <Legend.Item sx={{ flexDirection: "column" }} style={{ flexDirection: "column" }} {...legendItemProps} />
    );

    return (
        <Paper>
            <StyledChart
                data={props.data}
            ><Label text="Db szám"/>
                <ArgumentAxis tickFormat={format} labelComponent={ArgumentLabel}/>
                <ValueAxis
                    labelComponent={ValueLabel} > </ValueAxis>
                <LineSeries
                    name="Normál szabad"
                    valueField="cars"
                    argumentField="date"
                />
                <LineSeries
                    name="Rokkant szabad"
                    valueField="accessibles"
                    argumentField="date"
                />
                <LineSeries
                    name="E-töltő szabad"
                    valueField="chargers"
                    argumentField="date"
                />
                <LineSeries
                    name="Szabálytalan beállások"
                    valueField="illegal"
                    argumentField="date"
                />
                <Title  text="Dátum" position="bottom" />
                <Legend position="bottom" rootComponent={Root} itemComponent={LegendItem} labelComponent={Label} />
                <Title
                    text={`${props.parkingZoneTitle} ${"\n"}(${props.parkingPeriod})`}
                    textComponent={TitleText}
                />
                <EventTracker />
                <Tooltip contentComponent={CustomizedTooltip} />
            </StyledChart>
        </Paper>
    );
}
